<div
  class="tour-tooltip"
  [ngStyle]="style"
  [class.rtl]="isRtl"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="step.titleKey ? (step.titleKey | translate) : null"
  tabindex="-1"
>
  <div class="text-muted small text-gray-50 text-start">
    <span dir="ltr"
      >{{ formatStep(currentStepIndex) }} / {{ formatStep(total) }}</span
    >
  </div>

  @if (step.titleKey) {
  <div class="fw-semibold mt-3">{{ step.titleKey | translate }}</div>
  }
  <div
    class="mt-3"
    [class.fw-semibold]="!step.titleKey"
    [innerHTML]="step.descriptionKey | translate"
  ></div>

  <div class="d-flex gap-2 mt-4" [class.flex-row-reverse]="!isRtl">
    <button type="button" class="btn btn-primary" (click)="onNext()">
      {{ step.nextLabelKey || 'COMMON.Next' | translate }}
    </button>
    @if (step.previousLabelKey && currentStepIndex > 1) {
    <button type="button" class="btn btn-overly-primary" (click)="onPrevious()">
      {{ step.previousLabelKey | translate }}
    </button>
    } @else {
    <button type="button" class="btn btn-overly-primary" (click)="onClose()">
      {{ step.closeLabelKey || 'COMMON.Close' | translate }}
    </button>
    }
  </div>
</div>
